import Controller from '../../shared/logic/Controller';
import Workflow from '../../shared/model/workflow/Workflow';

export const className = 'Workflows';
export const dependenciesRunInState = '--NA';
export const fields = {
  list: []
};

export default class Workflows extends Controller {
  run = async (dependencies, dependenciesForAngular) => {
    const isInRunnableState = await this.init(
      [],
      dependencies,
      dependenciesForAngular,
      dependenciesRunInState
    );
    if (!isInRunnableState) {
      return;
    }
    this.Scope.set(
      {
        isReady: { Workflows: true }
      },
      true
    );
  };

  constructor(
    $rootScope,
    $scope,
    $state,
    $timeout,
    webpage,
    eventService,
    authenticationService
  ) {
    'ngInject';

    const angularDependencies = [
      $rootScope,
      $scope,
      $state,
      $timeout,
      webpage,
      eventService,
      authenticationService
    ];
    super(angularDependencies, {
      Storage: {
        Table: className
      },
      Scope: {
        Defaults: {
          Name: className
        }
      },
      Data: {
        Model: Workflow,
        ModelName: className,
        Requests: {
          available: {
            url: '/api/v1/workflows/available/',
            query: {
              orderBy: 'name',
              coerceTo: 'string',
              isDescending: false
            }
          }
        }
      }
    });

    this.run();
  }
}
